import { Avatar, avatarHashIdToColor, getAvatarInitials } from '@clay-run/glaze/avatar';

/**
 * The square account-initial tile: Glaze `Avatar`, its colour hashed from the
 * account id so one account always gets the same colour. `lg` beside the
 * Growth Strategist account header's title, the default. `md` on the Home
 * board's cards. `sm` in the Growth Strategist ledger's Account cell.
 *
 * Initials are Glaze's own `getAvatarInitials`: the first letter of each
 * word, at most two ("Acme Corp" is "AC"), "?" for a missing name. Glaze
 * splits on a plain space, so the name's other whitespace (tabs,
 * non-breaking spaces from pasted CRM names) is normalised first.
 */
export function GsAccountAvatar({
  accountId,
  name,
  size = 'lg',
}: {
  accountId: string;
  name: string | null;
  size?: 'sm' | 'md' | 'lg';
}) {
  return (
    <Avatar
      size={size}
      shape="square"
      fallbackString={getAvatarInitials((name ?? '').replace(/\s+/g, ' ').trim(), '?')}
      color={avatarHashIdToColor(accountId)}
      alt=""
      className="shrink-0"
    />
  );
}
